import { NotificationsList } from 'civil-status/view-models/notifications-list';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<NotificationsList, keyof NotificationsList>[] = [
  {
    id: 'holders',
    label: 'Intestatari',
  },
  {
    id: 'typeEvent',
    label: 'Tipo evento',
  },
  {
    id: 'typeContent',
    label: 'Tipo contenuto',
  },
  {
    id: 'description',
    label: 'Descrizione notifica',
  },
  {
    id: 'date',
    label: 'Data formazione',
  },
  {
    id: 'idAnsc',
    label: 'ID Ansc',
  },
  {
    id: 'municipalityCompetent',
    label: 'Comune competente',
  },
  {
    id: 'municipalityFormation',
    label: 'Comune formazione',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
